import { HttpClient } from './http-client';
import { Config } from '@/utilities/config';

const httpClient = new HttpClient({
    baseUrl: Config.ApiUrl,
    headers: { secret: Config.ApiSecretHeader },
});

export { httpClient };
